import * as select2 from './select2';

var psshSbsoluteCounter = 0;

let validatePhoneCodeSelector = function (isSubmit) {
    $('select.phone-code-selector').each(function(i) {
        let currentSelect = $(this);
        let currentSelectId = $(this).attr('id');
        let currentSelectedValue = $(currentSelect).val();
        let errorMessage = $(currentSelect).data('error-message');
        let errorMessageElement =  $(currentSelect).next('.select2-container');

        if (isSubmit) {
            $("#" + currentSelectId + "_error").remove();

            if ($(currentSelectedValue).selector.length === 0) {
                $(errorMessageElement).after('<div id="' + currentSelectId + '_error" class="errorBar" style=" margin-top: 8px;"><p>'+errorMessage+'</p></div>');
            }
        }

        if (!isSubmit && $(currentSelectedValue).selector.length > 0) {
            $("#" + currentSelectId + "_error").remove();
        }
    });

}

var addError = function (fieldKey, field, footerBar) {
    if (fieldKey.indexOf('user-login-form') >= 0) {
        fieldKey = fieldKey.replace('user-login-form_', '');
    }

    if (field.hasOwnProperty('errors')) {
        for (var key in field['errors']) {
            if (field['errors'].hasOwnProperty(key)) {
                if (field['errors'][key] === 'Udzielona odpowiedź jest przeciwwskazaniem do realizacji umowy.') {
                    psshSbsoluteCounter++;
                }

                if ($('#' + fieldKey + '_error').length === 0) {
                    if ($('#' + fieldKey).hasClass('countrySelect')) {
                        $('#' + fieldKey).addClass('error').attr('data-error', 'true').next('span').addClass('error').after('<div id="' + fieldKey + '_error" class="errorBar"><p>' + field['errors'][key] + '</p></div>');
                    } else {
                        $('#' + fieldKey).addClass('error').attr('data-error', 'true').after('<div id="' + fieldKey + '_error" class="errorBar"><p>' + field['errors'][key] + '</p></div>');
                    }
                    $('label[for="' + fieldKey + '"]').addClass('error');
                } else {
                    $('#' + fieldKey).addClass('error').removeAttr('data-error');
                    $('#' + fieldKey + '_error').html('<p>' + field['errors'][key] + '</p>');
                    $('label[for="' + fieldKey + '"]').addClass('error');
                }
            }
        }
    } else {
        if ($('#' + fieldKey + '_error').html() === '<p>Udzielona odpowiedź jest przeciwwskazaniem do realizacji umowy.</p>') {
            psshSbsoluteCounter--;
        }

        if ($('#' + fieldKey).hasClass('countrySelect')) {
            $('#' + fieldKey).next('span').removeClass('error');
        }
        $('#' + fieldKey).removeClass('error').removeAttr('data-error');
        $('#' + fieldKey + '_error').remove();
        $('label[for="' + fieldKey + '"]').removeClass('error');
    }

    if ($(document).find('.p__path--second').length > 0) {
        if (psshSbsoluteCounter > 0) {
            $(document).find('#second-step-path').hide();
            $(document).find('#second-step-partner-error').show();
        } else {
            $(document).find('#second-step-path').show();
            $(document).find('#second-step-partner-error').hide();
        }
    }
};

var formValidation = function (formName, errorList, fieldId, isSubmit) {
    if (fieldId !== null && fieldId.indexOf('phoneNumber_number') >= 0) {
        fieldId = fieldId.replace('phoneNumber_number', 'phoneNumber');
    }

    var footerBar = $('form[name="' + formName + '"]').attr('footer_bar');
    var addErrorResult = false;
    var addErrorFooter = false;

    if (footerBar === undefined) {
        footerBar = null;
    }

    var stack = [];
    var stackKeys = [];

    if (errorList.hasOwnProperty('children')) {
        for (var key in errorList['children']) {
            if (errorList['children'].hasOwnProperty(key)) {
                stack.push(errorList['children'][key]);
                stackKeys.push(formName + '_' + key);
            }
        }
    }

    while (stack.length !== 0 && stackKeys.length !== 0) {
        var field = stack.pop();
        var fieldKey = stackKeys.pop();

        if (field.hasOwnProperty('children')) {
            for (var key in field['children']) {
                if (field['children'].hasOwnProperty(key)) {
                    stack.push(field['children'][key]);
                    stackKeys.push(fieldKey + '_' + key);
                }
            }
        }

        if (fieldId === null) {
            addError(fieldKey, field, footerBar);
        } else {
            if (Array.isArray(fieldId)) {
                if (fieldId.indexOf(fieldKey) > -1) {
                    addError(fieldKey, field, footerBar);
                }
            } else {
                if (fieldId === fieldKey) {
                    addError(fieldKey, field, footerBar);
                }
            }
        }

        if (field.hasOwnProperty('errors')) {
            addErrorResult = true;
        }

        if (addErrorFooter === false && addErrorResult === true) {
            addErrorFooter = true;
        }
    }

    if (addErrorFooter === true) {
        if (footerBar !== null && isSubmit === true) {
            $('.errorFooter').html('<p>' + jsTranslations['messages']['form_fix_errors'] + '</p>');
        }
    } else {
        $('.errorFooter').html('');
    }
};


var conversionPathAjax = function ($form, params, fieldId, isSubmit, motherPeselOrDateOfBirthChanged) {
    return $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('check_parent_pesel') && data["check_parent_pesel"] === true) {
                $.ajax({
                    url: Routing.generate('app_conversion_path_second_step_pesel', {_locale: currentLocale,}),
                    type: "GET",
                    success: function (data) {
                        if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                            if (data["sessionChanged"] === true) {
                                window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                            }
                        }

                        $(".p__path--second").append(data);
                        $('body').addClass('unscroll');
                    },
                    error: function (jqXHR, textStatus, errorThrown) {

                        if (jqXHR.status === 401) {
                            window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                        }
                    }
                });
            } else if (isSubmit && data.hasOwnProperty('decision') && data["decision"] === true) {
                $.ajax({
                    url: $form.attr('data-deci-url'),
                    type: "GET",
                    success: function (data) {

                        if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                            if (data["sessionChanged"] === true) {
                                window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                            }
                        }

                        $(".p__path--second").append(data);
                        $('body').addClass('unscroll');
                    },
                    error: function (jqXHR, textStatus, errorThrown) {

                        if (jqXHR.status === 401) {
                            window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                        }
                    }
                });
            } else if (isSubmit && data.hasOwnProperty('newAccount') && data["newAccount"] === true) {
                $.ajax({
                    url: $form.attr('data-acco-url'),
                    type: "GET",
                    success: function (data) {

                        if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                            if (data["sessionChanged"] === true) {
                                window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                            }
                        }

                        $(".p__path--second").append(data);
                        $('body').addClass('unscroll');
                    },
                    error: function (jqXHR, textStatus, errorThrown) {

                        if (jqXHR.status === 401) {
                            window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                        }
                    }
                });
            } else if (isSubmit && data.hasOwnProperty('existingUser') && data["existingUser"] === true) {
                $.ajax({
                    url: $form.attr('data-user-url'),
                    type: "GET",
                    success: function (data) {

                        if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                            if (data["sessionChanged"] === true) {
                                window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                            }
                        }

                        $(".p__path--second").append(data);
                        $('body').addClass('unscroll');
                    },
                    error: function (jqXHR, textStatus, errorThrown) {

                        if (jqXHR.status === 401) {
                            window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                        }
                    }
                });
            } else if (isSubmit && data.hasOwnProperty('confirmationUrl')) {

                window.location.href = Routing.generate(data['confirmationUrl'], {_locale: currentLocale,});
            } else if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {

                auth(data['mfaUrl']);
            } else {

                if (isSubmit && data["success"]) {
                    $('.errorBar').html('');
                    $form.submit();
                } else {
                    $('.info-service-not-available').hide();
                    if (typeof data["additionalPackagesValid"] !== 'undefined') {
                        if(data["additionalPackagesValid"]["result"] == false){
                            $('.info-service-not-available').show();
                        }
                    }
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                    validatePhoneCodeSelector(isSubmit);

                    if (motherPeselOrDateOfBirthChanged === true) {
                        if (data.hasOwnProperty('peselUnderEighteen') && data.hasOwnProperty('dateOfBirthUnderEighteen')) {
                            if (data["peselUnderEighteen"] === true || data["dateOfBirthUnderEighteen"] === true) {
                                if ($('[data-partner]').length) {
                                    var attr = $('[data-partner]').attr('data-partner');

                                    toastr.options = {
                                        "timeOut": "15000"
                                    };

                                    if (attr === 'false') {
                                        toastr.info(jsTranslations['messages']['mother_not_adult']);
                                    } else {
                                        toastr.info(jsTranslations['messages']['mother_not_adult_partner']);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (textStatus === 'error') {
                window.location.href = Routing.generate('root', {_locale: currentLocale,});
            }

            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};

var jqxhr_cpf;
var conversionPathForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_cpf) {
        jqxhr_cpf.abort();
    }
    jqxhr_cpf = conversionPathAjax($form, params, fieldId, isSubmit);
};

var conversionPathThirdStepForm = function ($form, params, fieldId, isSubmit, motherPeselOrDateOfBirthChanged) {
    conversionPathAjax($form, params, fieldId, isSubmit, motherPeselOrDateOfBirthChanged);
};

var conversionPathFourthStepForm = function ($form, params, fieldId, isSubmit) {
    conversionPathAjax($form, params, fieldId, isSubmit);
};

var jqxhr_af;
var accountForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_af) {
        jqxhr_af.abort();
    }
    jqxhr_af = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data["success"]) {
                $form.submit();
            } else {
                formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};

var jqxhr_uf;
var userForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_uf) {
        jqxhr_uf.abort();
    }
    jqxhr_uf = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data["success"]) {
                $form.submit();
            } else {
                formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};

//Validacja pierwszego kroku
if ($('.p__path--first').length) {
    $(document).on("click", "#conversion_path_submit", function (e) {
        var $form = $(this).closest('form');

        conversionPathForm($form, $form.serializeArray(), null, true);
    });
}

var changeMaterialFunc = function ($form, callback) {
    $.ajax({
        url: $form.attr('action') + '?chanmat=true',
        type: $form.attr('method'),
        data: $form.serializeArray(),
        success: function (html) {
            $('.additional').html($(html).find('.additional').html());
            $('.additional').find('[uncheck=1]').prop('checked', false);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    }).done(callback);

    conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step_material', false);
};

var checkedAddonsFunc = function () {
    let show = false;
    $('.additional input:checkbox').each(function() {
        if($(this).is(':checked') == true && $(this).parent()[0].id != 'optional-price_guarantee') {
            let blockingPackage = $(this).data('blocking-package');
            if (typeof blockingPackage !== "undefined") {
                if(blockingPackage.length > 0){
                    $('#' + blockingPackage).addClass('disabled striked');
                    $('#' + blockingPackage + ' input').prop('disabled', true);
                }
            }
            show = true;
        }
    });

    if ($('#app_conversion_path_second_step_companyCode').val() !== 'BC4') {
        show = false;
    }

    if (show == true) {
        $('#app_conversion_path_second_step__additionalPackagesValidate').show();
    } else {
        $('#app_conversion_path_second_step__additionalPackagesValidate').hide();
    }
};

var formForceUncheck = function() {
    if(!$('form.force-uncheck input[type="checkbox"]:checked').length) {
        return;
    }

    var target = $('form.force-uncheck input[type="checkbox"]:checked').first();

    if(target.is(':disabled')) {
        target.prop('checked', false);
    } else {
        target.click();
    }

    if($('form.force-uncheck input[type="checkbox"]:checked').length) {
        setTimeout(function() {
            formForceUncheck();
        }, 200);
    }
}

var unlockPriceGuarantee = function () {
    let price_guarantee_input = $('#optional-price_guarantee input');
    let show = false;

    $('#app_conversion_path_second_step__storage_1, #app_conversion_path_second_step__additionalPackages_1, #app_conversion_path_second_step__additionalPackages_2').each(function() {
        if($(this).is(':checked') == true) {
            show = true;
        }
    });

    // if for free
    if(price_guarantee_input.attr('checked') && !price_guarantee_input.attr('disabled')) {
        $('#optional-price_guarantee input').prop('checked', true);
    }

    // disable for upsale
    if(window.location.href.includes('additional-packages')) {
        show = false;
    }

    if (show == true) {
        $('#optional-price_guarantee').removeClass('disabled striked');
        $('#optional-price_guarantee input').prop('disabled', false);
    } else {
        $('#optional-price_guarantee').addClass('disabled striked');
        $('#optional-price_guarantee input').prop('disabled', true);
        $('#optional-price_guarantee input').prop('checked', false);
    }
    
    
};

var changeAddonsFunc = function ($target) {
    $('#app_conversion_path_second_step__additionalPackages_error').remove();
    let blockingPackage = $($target).data('blocking-package');
    if (typeof blockingPackage === "undefined") {
        return;
    }
    if(blockingPackage.length <= 0){
        return;
    }
    let dataDisabled = $('#' + blockingPackage + ' input').data('disabled');
    if(true === $target.checked) {
        $('#' + blockingPackage).addClass('disabled striked');
        $('#' + blockingPackage + ' input').prop('disabled', true);
    }else{
        if(typeof dataDisabled === "undefined"){
            $('#' + blockingPackage).removeClass('disabled striked');
            $('#' + blockingPackage + ' input').prop('disabled', false);
        }
    }
};

var validateAdditionalPackage = function () {

    let validate = false;
    $('.additional input:checkbox').each(function() {
        if ($(this).is(':checked') == true) {
            validate = true;
        }
    });

    if(false === validate){
        $('.info-service-not-available').hide();
        $('.info-service-available').hide();
        return;
    }

    let $form = $("form[name='app_conversion_path_second_step']");

    $('.info-service-not-available').hide();
    $('.info-service-available').hide();
    $('.info-service-invalid-cryosave').hide();
    $('.btn-check-additional-packages').on( "click", function() {
        let selfBtn = $(this);
        let cryosaveAgreementNumber = $('#app_conversion_path_second_step_cryosaveAgreementNumber').val();
        if(typeof cryosaveAgreementNumber !== 'undefined' && cryosaveAgreementNumber.length > 0){
            selfBtn.html(selfBtn.data('label-checking'));
            $('.info-service-invalid-cryosave').hide();
            // let regexp = new RegExp('^[a-zA-Z0-9_]+\\/[a-zA-Z0-9]+(\\/[a-zA-Z0-9]+)?$');
            // if(cryosaveAgreementNumber.length >= 3 && cryosaveAgreementNumber.length <= 14 && regexp.test(cryosaveAgreementNumber) === true) {
            if(cryosaveAgreementNumber.length >= 3 && cryosaveAgreementNumber.length <= 14) {
                jqxhr = $.ajax({
                    url: $form.attr('data-addons-validate-url'),
                    type: "POST",
                    data: $form.serialize(),
                    success: function (data) {
                        if (data.result === false) {
                            $('.info-service-not-available').show();
                        } else {
                            $('.info-service-available').show();
                        }
                        selfBtn.html(selfBtn.data('label-default'));
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        if (jqXHR.status === 401) {
                            window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                        }
                        selfBtn.html(selfBtn.data('label-default'));
                    }

                });
            }else{
                selfBtn.html(selfBtn.data('label-default'));
                $('.info-service-invalid-cryosave').show();
            }
        }
        selfBtn.html(selfBtn.data('label-default'));
    });
}

if ($('[checked="checked"]', '.storage-years-box .prepayments-row').length) {
    $('.storage-years-box .prepayments-row').addClass('active');
}

var changeStorageYearsPaidFunc = function ($form, callback) {
    $.ajax({
        url: $form.attr('action') + '?chansyp=true',
        type: $form.attr('method'),
        data: $form.serializeArray(),
        success: function (html) {
            var inputText = $(html).find('input[type="radio"]:checked+label').text();
            var htmlToInsert = $(html).find('.storageYearsPaidOther').html();

            // if (inputText.indexOf('*') > -1) {
            //     // $('.storage-years-box .additional-info').css('visibility','visible');
            //     $('.storage-years-box .additional-info').fadeTo(300,1);
            // } else {
            //     // $('.storage-years-box .additional-info').css('visibility','hidden');
            //     $('.storage-years-box .additional-info').fadeTo(300,0);
            // }

            $('.storage-years-box .prepayments-row').addClass('active');

            if (htmlToInsert.length < 150) {
                $('.cryo-years .inputs.other').removeClass('active');
                $('.storageYearsPaidOther').html(htmlToInsert);
            } else {
                $('.storageYearsPaidOther').html(htmlToInsert);
                $('.cryo-years .inputs.other').addClass('active');
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    }).done(callback);

    conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step_storageYearsPaid', false);
};

var changeTransferCountryCodeFunc = function ($form, callback) {
    $.ajax({
        url: $form.attr('action') + '?chantcc=true',
        type: $form.attr('method'),
        data: $form.serializeArray(),
        success: function (html) {
            $('.additional').html($(html).find('.additional').html());

            if($(html).find('#labs-list').find('input[type="radio"]:checked').length > 0){
                $('a.resignation').addClass('active');
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    }).done(callback);

    conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step_transferCountryCode', false);
};
var changePrepaymentFunc = function ($form, callback) {
    $.ajax({
        url: $form.attr('action') + '?chanpp=true',
        type: $form.attr('method'),
        data: $form.serializeArray(),
        success: function (html) {
            $('.additional').html($(html).find('.additional').html());
            var $prepayments = $('#app_conversion_path_second_step_prepayment .prepayment');
            $.each($prepayments, function () {
                var $this = $(this);

                if ($this.find('input').prop('checked')) {
                    $this.removeClass('not-checked');
                } else {
                    $this.addClass('not-checked');
                }
            })
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    }).done(callback);

    conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step_prepayment', false);
};

var changeStorageFunc = function ($form, callback) {
    $.ajax({
        url: $form.attr('action') + '?chanst=true',
        type: $form.attr('method'),
        data: $form.serializeArray(),
        success: function (html) {
            $('.additional').html($(html).find('.additional').html());
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    }).done(callback);

    conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step__storage', false);
};

var changecountryOfOriginCodeFunc = function ($form, callback) {
    $.ajax({
        url: $form.attr('action') + '?chancooc=true',
        type: $form.attr('method'),
        data: $form.serializeArray(),
        success: function (html) {
            $('.additional').html($(html).find('.additional').html());
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    }).done(callback);

    conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step_countryOfOriginCode', false);
};

var changelanguageSupportFunc = function ($form, callback) {
    $.ajax({
        url: $form.attr('action') + '?chanls=true',
        type: $form.attr('method'),
        data: $form.serializeArray(),
        success: function (html) {
            $('.additional').html($(html).find('.additional').html());
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    }).done(callback);

    conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step_languageSupport', false);
};

var changePackFunc = function ($form, callback) {
    $('#app_conversion_path_second_step_instalmentBaseVariantAndAddons').prop('checked', false);
    $('.installHide1').removeClass('active');
    $('#app_conversion_path_second_step_instalmentStorage').prop('checked', false);
    $('.installHide2').removeClass('active');
    $("[id*='app_conversion_path_second_step_instalmentBaseVariantAndAddonsQuantity_']").each(function () {
        $(this).prop('checked', false);
        $('#installment-checked').removeClass('active');

    });
    $("[id*='app_conversion_path_second_step_instalmentStorageQuantity_']").each(function () {
        $(this).prop('checked', false);
        $('#installment-checked').removeClass('active');
    });

    $.ajax({
        url: $form.attr('action') + '?chanpack=true',
        type: $form.attr('method'),
        data: $form.serializeArray(),
        success: function (html) {
            $('.abonament').html($(html).find('.abonament').html());
            $('.additional').html($(html).find('.additional').html());
            $('.insurance').html($(html).find('.insurance').html());
            $('.number-of-installment').html($(html).find('.number-of-installment').html());
            $('.charge-type').html($(html).find('.charge-type').html());

            $('.ktg').html($(html).find('.ktg').html());
            $('.ktg_lightbox').html($(html).find('.ktg_lightbox').html());
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    }).done(callback);

    conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step__package', false);
};

var changeKtgPackFunc = function ($form) {
    $.ajax({
        url: $form.attr('action') + '?chanpack=true',
        type: $form.attr('method'),
        data: $form.serializeArray(),
        success: function (html) {
            $('.ktg').html($(html).find('.ktg').html());
            $('.ktg_lightbox').html($(html).find('.ktg_lightbox').html());

            var elementToReplace = $(html).find('#app_ktg_path_first_step__ktgPackage');

            $('#app_ktg_path_first_step__ktgPackage').replaceWith(elementToReplace);

            if (parseInt(elementToReplace.attr('data-children')) === 4) {
                if ($('.ktgMobile').length > 0) {
                    $('.variantWrapper').first().find('input').prop('checked', true).trigger('change');
                } else {
                    $('.variant').first().find('input').prop('checked', true).trigger('change');
                }

            }

            if ($('[name="app_ktg_path_first_step[_ktgPackage]"]:checked').length) {
                var val = $('[name="app_ktg_path_first_step[_ktgPackage]"]:checked').attr('data');
                $('.' + val).addClass('active');
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });

    ktgPathForm($form, $form.serializeArray(), 'app_ktg_path_first_step__ktgPackage', false);
};

//Walidacja drugiego kroku
if ($('.p__path--second').length) {

    $(document).on("click", "#conversion_path_submit", function (e) {
        let $form = $(this).closest('form');
        if (!$("input[name='app_conversion_path_second_step[prepayment]']:checked").val()) {
            $('#app_conversion_path_second_step_prepayment_error').show();
        }
        conversionPathForm($form, $form.serializeArray(), null, true);
    });

    var loader = $('.loader');

    checkedAddonsFunc();
    unlockPriceGuarantee();
    validateAdditionalPackage();

    $(document).on("change", "form[name='app_conversion_path_second_step']", function (e) {
        let $form = $(this);
        let $target = e.target;

        checkedAddonsFunc();
        unlockPriceGuarantee();
        validateAdditionalPackage();

        if ($target.id !== 'app_conversion_path_second_step_promoCode' && e.target.id !== 'app_conversion_path_second_step_promoCodeBirthDays') {
            if (e.target.id.indexOf('app_conversion_path_second_step__package_') >= 0) {
                changePackFunc($form, function () {
                    checkedAddonsFunc();
                    unlockPriceGuarantee();
                    calculateAjax($form, validateAjax);
                });
            } else if (e.target.id.indexOf('app_conversion_path_second_step_material_') >= 0) {
                changeMaterialFunc($form, function () {
                    checkedAddonsFunc();
                    unlockPriceGuarantee();
                    calculateAjax($form, validateAjax);
                });
            } else if (e.target.id.indexOf('app_conversion_path_second_step_storageYearsPaid_') >= 0) {
                changeStorageYearsPaidFunc($form, function () {
                    checkedAddonsFunc();
                    unlockPriceGuarantee();
                    calculateAjax($form, validateAjax);
                });
            } else if (e.target.id.indexOf('app_conversion_path_second_step_storageYearsPaidOther') >= 0) {
                conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step_storageYearsPaidOther', false);
            } else if (e.target.id.indexOf('app_conversion_path_second_step_transferCountryCode_') >= 0) {
                changeTransferCountryCodeFunc($form, function () {
                    checkedAddonsFunc();
                    unlockPriceGuarantee();
                    calculateAjax($form, validateAjax);
                });
            } else if (e.target.id.indexOf('app_conversion_path_second_step_prepayment_') >= 0) {
                changePrepaymentFunc($form, function () {
                    checkedAddonsFunc();
                    unlockPriceGuarantee();
                    calculateAjax($form, validateAjax);
                });
            } else if (e.target.id.indexOf('app_conversion_path_second_step__storage_') >= 0) {
                changeStorageFunc($form, function () {
                    checkedAddonsFunc();
                    unlockPriceGuarantee();
                    calculateAjax($form, validateAjax);
                });
            } else if (e.target.id.indexOf('app_conversion_path_second_step_countryOfOriginCode') >= 0) {
                changecountryOfOriginCodeFunc($form, function () {
                    checkedAddonsFunc();
                    unlockPriceGuarantee();
                    calculateAjax($form, validateAjax);
                });
            } else if (e.target.id.indexOf('app_conversion_path_second_step_languageSupport') >= 0) {
                changelanguageSupportFunc($form, function () {
                    checkedAddonsFunc();
                    unlockPriceGuarantee();
                    calculateAjax($form, validateAjax);
                });
            } else if (e.target.id.indexOf('app_conversion_path_second_step_years_') >= 0) {
                $('#app_conversion_path_second_step_instalmentStorage').prop('checked', false);
                $('.installHide2').removeClass('active');
                $("[id*='app_conversion_path_second_step_instalmentStorageQuantity_']").each(function () {
                    $(this).prop('checked', false);
                });

                $.ajax({
                    url: $form.attr('action') + '?chanyear=true',
                    type: $form.attr('method'),
                    data: $form.serializeArray(),
                    success: function (html) {
                        $('.number-of-installment').html($(html).find('.number-of-installment').html());
                        $('.charge-type').html($(html).find('.charge-type').html());
                        $('.additional').html($(html).find('.additional').html());

                        conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step_years', false);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        if (jqXHR.status === 401) {
                            window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                        }
                    }
                }).done(calculateAjax($form, validateAjax));
            } else if (e.target.id.indexOf('app_conversion_path_second_step_instalmentBaseVariantAndAddons') >= 0) {
                $.ajax({
                    url: $form.attr('action') + '?chaninsqua=true',
                    type: $form.attr('method'),
                    data: $form.serializeArray(),
                    success: function (html) {
                        $('.number-of-installment').html($(html).find('.number-of-installment').html());
                        $('.charge-type').html($(html).find('.charge-type').html());
                        $('#installment-checked').addClass('active');
                        if ($('#app_conversion_path_second_step_instalmentBaseVariantAndAddons').is(':checked') || $('#app_conversion_path_second_step_instalmentStorage').is(':checked')) {
                            $('#installment-checked').addClass('active');
                            if ($('#app_conversion_path_second_step_instalmentBaseVariantAndAddons').is(':checked')) {
                                $('.installHide1').addClass('active');
                            } else {
                                $('.installHide1').removeClass('active');
                            }
                        } else {
                            $('#installment-checked').removeClass('active');
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        if (jqXHR.status === 401) {
                            window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                        }
                    }
                }).done(calculateAjax($form, validateAjax));
            } else if (e.target.id.indexOf('app_conversion_path_second_step_instalmentStorage') >= 0) {
                $.ajax({
                    url: $form.attr('action') + '?chaninsqua=true',
                    type: $form.attr('method'),
                    data: $form.serializeArray(),
                    success: function (html) {
                        $('.number-of-installment').html($(html).find('.number-of-installment').html());
                        $('.charge-type').html($(html).find('.charge-type').html());
                        if ($('#app_conversion_path_second_step_instalmentBaseVariantAndAddons').is(':checked') || $('#app_conversion_path_second_step_instalmentStorage').is(':checked')) {
                            $('#installment-checked').addClass('active');
                            if ($('#app_conversion_path_second_step_instalmentStorage').is(':checked')) {
                                $('.installHide2').addClass('active');
                            } else {
                                $('.installHide2').removeClass('active');
                            }
                        } else {
                            $('#installment-checked').removeClass('active');
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        if (jqXHR.status === 401) {
                            window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                        }
                    }
                }).done(calculateAjax($form, validateAjax));
            } else if (e.target.id.indexOf('app_conversion_path_second_step_haquestionnaire') >= 0) {
                $.ajax({
                    url: $form.attr('action') + '?chanhaq=true',
                    type: $form.attr('method'),
                    data: $form.serializeArray(),
                    success: function (html) {
                        $('.variants').html($(html).find('.variants').html());
                        $('.abonament').html($(html).find('.abonament').html());
                        $('.additional').html($(html).find('.additional').html());
                        $('.insurance').html($(html).find('.insurance').html());
                        $('.number-of-installment').html($(html).find('.number-of-installment').html());
                        $('.charge-type').html($(html).find('.charge-type').html());

                        $('.ktg').html($(html).find('.ktg').html());
                        $('.ktg_lightbox').html($(html).find('.ktg_lightbox').html());
                        conversionPathForm($form, $form.serializeArray(), e.target.id.substr(0, e.target.id.lastIndexOf('_')), false);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        if (jqXHR.status === 401) {
                            window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                        }
                    }
                }).done(calculateAjax($form, validateAjax));
            } else {
                changeAddonsFunc($target);
                unlockPriceGuarantee();
                calculateAjax($form, validateAjax);
            }
        }
    });

    $(document).on('click', ".resignation", function (e) {
        if($(e.target).hasClass('active')){
            $('input[name="app_conversion_path_second_step[transferCountryCode]"][value!="PL"]').prop('checked', false).trigger("change");
            $('[data-code="optional.transplant"]').prop('checked', false);
            $('input[name="app_conversion_path_second_step[transferCountryCode]"][value="PL"]').prop('checked', true).trigger("change");
            calculateAjax($(this).closest('form'), validateAjax);
            $(e.target).removeClass('active');
        }
    });

    $(document).on("click", "#second-step-pesel-show", function (e) {
        e.preventDefault();
        $.ajax({
            url: $(this).data('href'),
            type: "GET",
            success: function (data) {
                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                    if (data["sessionChanged"] === true) {
                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                    }
                }

                $(".p__path--second").append(data);
                $('body').addClass('unscroll');
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401) {
                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                }
            }
        });
    });

    $(document).on("click", "#second-step-agreement-btn", function (e) {
        e.preventDefault();

        var $form = $(this).closest('form');

        $('.lightbox_content .loader').show();

        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serializeArray(),
            success: function (data) {
                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                    if (data["sessionChanged"] === true) {
                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                    }
                }

                if (data.hasOwnProperty('isDiscount') && data['isDiscount'] === true) {
                    var $formSecond = $(document).find("form[name='app_conversion_path_second_step']");
                    $('#app_conversion_path_second_step_promoCode').val('');

                    changePackFunc($formSecond, function () {
                        calculateAjax($formSecond, validateAjax);
                        unlockPriceGuarantee();
                    });

                    $(".success__panel").slideDown();
                    $(".lastattempt__panel").slideUp();
                    $(".go-further").slideUp();
                    $(".error__panel").slideUp();
                    $(".error-time__panel").slideUp();
                } else {
                    if (data.hasOwnProperty('isLastAttempt') && data['isLastAttempt'] === true) {
                        $(".lastattempt__panel").slideDown();
                        $(".success__panel").slideUp();
                        $(".go-further").slideUp();
                        $(".error__panel").slideUp();
                        $(".error-time__panel").slideUp();
                    } else if (data.hasOwnProperty('isTimeOut') && data['isTimeOut'] === true) {
                        $(".error-time__panel").slideDown();
                        $(".lastattempt__panel").slideUp();
                        $(".success__panel").slideUp();
                        $(".go-further").slideUp();
                        $(".error__panel").slideUp();
                    } else {
                        if (data.hasOwnProperty('valid') && data['valid'] === false) {
                            formValidation($form.attr("name"), $.parseJSON(data["errorList"]), null, false);
                        } else {
                            $(".lastattempt__panel").slideUp();
                            $(".success__panel").slideUp();
                            $(".error-time__panel").slideUp();
                            $(".go-further").slideDown();
                            $(".error__panel").slideDown();
                        }
                    }
                }

                $('.lightbox_content .loader').hide();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401) {
                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                }
            }
        });
    });

    $(document).on("click", "#second-step-back-decision-btn", function (e) {
        e.preventDefault();

        var $form = $(this).closest('form');

        $.ajax({
            url: $form.attr('data-deci-url'),
            type: "GET",
            success: function (data) {
                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                    if (data["sessionChanged"] === true) {
                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                    }
                }

                $('.lightbox_wrapper[indirect-step]').remove();
                $('body').addClass('unscroll');
                $(".p__path--second").append(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401) {
                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                }
            }
        });
    });

    $(document).on("click", "#second-step-back-account-btn", function (e) {
        e.preventDefault();

        var $form = $(this).closest('form');

        $.ajax({
            url: $form.attr('data-acc-url'),
            type: "GET",
            success: function (data) {
                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                    if (data["sessionChanged"] === true) {
                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                    }
                }

                $('.lightbox_wrapper[indirect-step]').remove();
                $('body').addClass('unscroll');
                $(".p__path--second").append(data);
                $('.countrySelect').each(function () {
                    $(this).select2();
                    if ($(this).val() == 'PL') {
                        $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
                    }
                });
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401) {
                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                }
            }
        });
    });

    $(document).on("click", "#second-step-decision-btn", function (e) {
        e.preventDefault();

        var $form = $(this).closest('form');

        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serializeArray(),
            success: function (data) {
                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                    if (data["sessionChanged"] === true) {
                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                    }
                }

                if (data.hasOwnProperty('newAccount') && data.hasOwnProperty('existingUser') && data.hasOwnProperty('url') && data.hasOwnProperty('token')) {
                    if (data['newAccount'] === true && data['existingUser'] === false) {
                        $.ajax({
                            url: Routing.generate(data['url'], {_locale: currentLocale, token: data['token']}),
                            type: "GET",
                            success: function (data) {
                                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                                    if (data["sessionChanged"] === true) {
                                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                                    }
                                }

                                $('.lightbox_wrapper[indirect-step]').remove();
                                $('body').addClass('unscroll');
                                $(".p__path--second").append(data);
                                $('.countrySelect').each(function () {
                                    $(this).select2();
                                    if ($(this).val() == 'PL') {
                                        $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
                                    }
                                });
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                if (jqXHR.status === 401) {
                                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                                }
                            }
                        });
                    } else if (data['newAccount'] === false && data['existingUser'] === true) {
                        $.ajax({
                            url: Routing.generate(data['url'], {_locale: currentLocale, token: data['token']}),
                            type: "GET",
                            success: function (data) {
                                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                                    if (data["sessionChanged"] === true) {
                                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                                    }
                                }

                                $('.lightbox_wrapper[indirect-step]').remove();
                                $('body').addClass('unscroll');
                                $(".p__path--second").append(data);
                                $('.countrySelect').each(function () {
                                    $(this).select2();
                                    if ($(this).val() == 'PL') {
                                        $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
                                    }
                                });
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                if (jqXHR.status === 401) {
                                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                                }
                            }
                        });
                    } else {
                        window.location.href = Routing.generate(data['url'], {
                            _locale: currentLocale,
                            token: data['token']
                        });
                    }
                } else if (data.hasOwnProperty('newAccount') && data.hasOwnProperty('existingUser') && data.hasOwnProperty('url')) {
                    if (data['newAccount'] === true && data['existingUser'] === false) {
                        $.ajax({
                            url: Routing.generate(data['url'], {_locale: currentLocale,}),
                            type: "GET",
                            success: function (data) {
                                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                                    if (data["sessionChanged"] === true) {
                                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                                    }
                                }

                                $('.lightbox_wrapper[indirect-step]').remove();
                                $('body').addClass('unscroll');
                                $(".p__path--second").append(data);
                                $('.countrySelect').each(function () {
                                    $(this).select2();
                                    if ($(this).val() == 'PL') {
                                        $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
                                    }
                                });
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                if (jqXHR.status === 401) {
                                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                                }
                            }
                        });
                    } else if (data['newAccount'] === false && data['existingUser'] === true) {
                        $.ajax({
                            url: Routing.generate(data['url'], {_locale: currentLocale,}),
                            type: "GET",
                            success: function (data) {
                                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                                    if (data["sessionChanged"] === true) {
                                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                                    }
                                }

                                $('.lightbox_wrapper[indirect-step]').remove();
                                $('body').addClass('unscroll');
                                $(".p__path--second").append(data);
                                $('.countrySelect').each(function () {
                                    $(this).select2();
                                    if ($(this).val() == 'PL') {
                                        $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
                                    }
                                });
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                if (jqXHR.status === 401) {
                                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                                }
                            }
                        });
                    } else {
                        window.location.href = Routing.generate(data['url'], {_locale: currentLocale,});
                    }
                } else {
                    if (data.hasOwnProperty('newAccount') && data.hasOwnProperty('url')) {
                        if (data['newAccount'] === true) {
                            var url = Routing.generate(data['url'], {_locale: currentLocale,});

                            if (data.hasOwnProperty('reflection')) {
                                url += '?reflection=' + data['reflection'];
                            }

                            $.ajax({
                                url: url,
                                type: "GET",
                                success: function (data) {
                                    if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                                        if (data["sessionChanged"] === true) {
                                            window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                                        }
                                    }

                                    $('.lightbox_wrapper[indirect-step]').remove();
                                    $('body').addClass('unscroll');
                                    $(".p__path--second").append(data);
                                    $('.countrySelect').each(function () {
                                        $(this).select2();
                                        if ($(this).val() == 'PL') {
                                            $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
                                        }
                                    });
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    if (jqXHR.status === 401) {
                                        window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                                    }
                                }
                            });
                        } else {
                            window.location.href = Routing.generate(data['url'], {_locale: currentLocale,});
                        }
                    }
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401) {
                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                }
            }
        });
    });

    $(document).on("change", "form[name='app_conversion_path_second_step_account']", function (e) {
        var $form = $(this);
        if (e.target.id.indexOf('_phoneNumber_country') >= 0 && e.target.id.indexOf('_phoneNumber_number') >= 0) {
            accountForm($form, $form.serializeArray(), e.target.id.replace('_phoneNumber_country', '_phoneNumber_number'), false);
        } else {
            accountForm($form, $form.serializeArray(), e.target.id, false);
        }
    });

    $(document).on("click", "#second-step-account-btn", function (e) {
        var $form = $(this).closest('form');

        accountForm($form, $form.serializeArray(), null, true);
    });

    $(document).on("click", "#second-step-user-btn", function (e) {
        var $form = $(this).closest('form');

        userForm($form, $form.serializeArray(), null, true);
    });

    $(document).on("click", "#second-step-login-btn", function (e) {
        var isReflection = '';

        if ($(this).attr('data-reflection') === '1') {
            isReflection = '?reflection=true'
        }

        $.ajax({
            url: Routing.generate('app_conversion_path_second_step_login', {_locale: currentLocale,}) + isReflection,
            type: 'GET',
            success: function (data) {
                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                    if (data["sessionChanged"] === true) {
                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                    }
                }

                $('.lightbox_wrapper').remove();
                $(".p__path--second").append(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401) {
                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                }
            }
        });
    });

    var validateAjax = function ($form) {
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            success: function (data) {
                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                    if (data["sessionChanged"] === true) {
                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                    }
                }

                loader.fadeOut(100);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401) {
                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                }
            }
        });
    };
    var jqxhr;

    var calculateAjax = function ($form, callback) {
        loader.fadeIn(100);
        jqxhr = $.ajax({
            url: $form.attr('data-calc-url'),
            type: "POST",
            data: $form.serialize(),
            success: function (data) {
                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                    if (data["sessionChanged"] === true) {
                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                    }
                }

                // boczny panel
                $("#storage_fee").html((data.selected.storage / 100) + ' <span class="currency">&euro;</span>');
                $("#addons_fee").html((data.selected.addons / 100) + ' <span class="currency">&euro;</span>');
                $("#transfer_fee").html((data.selected.transfer / 100) + ' <span class="currency">&euro;</span>');
                $("#after_sign_fee").html((data.summary.after_sign / 100) + ' <span class="currency">&euro;</span>');
                $("#after_cryo_fee").html((data.summary.after_cryo / 100) + ' <span class="currency">&euro;</span>');

                if ((data.selected.storage / 100) !== (data.selected_standard.storage / 100)) {
                    $("#storage_fee_standard").html((data.selected_standard.storage / 100) + ' <span class="currency">&euro;</span>');
                    $("#storage_fee_standard").fadeIn(300);
                } else {
                    $("#storage_fee_standard").html('');
                    $("#storage_fee_standard").removeClass('active');
                }

                if ((data.selected.addons / 100) !== (data.selected_standard.addons / 100)) {
                    $("#addons_fee_standard").html((data.selected_standard.addons / 100) + ' <span class="currency">&euro;</span>');
                    $("#addons_fee_standard").fadeIn(300);
                } else {
                    $("#addons_fee_standard").html('');
                    $("#addons_fee_standard").removeClass('active');
                }

                if ((data.selected.transfer / 100) !== (data.selected_standard.transfer / 100)) {
                    $("#transfer_fee_standard").html((data.selected_standard.transfer / 100) + ' <span class="currency">&euro;</span>');
                    $("#transfer_fee_standard").fadeIn(300);
                } else {
                    $("#transfer_fee_standard").html('');
                    $("#transfer_fee_standard").removeClass('active');
                }
                // addons list
                if(data.selected.addons_list.length !== 0){
                    $('.additional-packages-hidden').show();
                    $('.defaultLastRowLeft').removeClass('roundBottomLeft')
                    $('.defaultLastRowRight').removeClass('roundBottomRight')
                    $( ".addons-list" ).remove();
                    $.each(data.selected.addons_list, function (key, addon) {
                        let roundBottomLeft = (addon.last === true) ? 'roundBottomLeft' : '';
                        let roundBottomRight = (addon.last === true) ? 'roundBottomRight' : '';
                        let divTableRow = '<div class="divTableRow addons-list">'+
                            '<div class="divTableCell ' + roundBottomLeft + ' width38 fontSize16 fontColorNavy colorWhite borderDashedTop">' + addon.name + '</div>'+
                            '<div class="divTableCell ' + roundBottomRight +' width12 fontSize14 fontColorNavy colorWhite borderDashedTop">' + (addon.client_price / 100) + '<span class="currency">&nbsp;&euro;' + addon.payment_shortcut + '</span></div>'+
                            '<div class="divTableCell width50 fontSize16 fontColorWhite borderDashedTop">' + addon.payment_info + '</div>'+
                        '</div>';
                        $('.divTableBody').append(divTableRow);
                    });
                }else{
                    $('.additional-packages-hidden').hide();
                    $('.defaultLastRowLeft').addClass('roundBottomLeft')
                    $('.defaultLastRowRight').addClass('roundBottomRight')
                    $('.addons-list' ).remove();
                }
                loader.fadeOut(100);

                // callback($form);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401) {
                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                }
            }
        });
        return jqxhr;
    };
}

if ($('.p__path--second').length) {
    $(document).on("click", "#discount-km-button-submit", function (e) {
        var $form = $(this).closest('form');

        $.ajax({
            url: $form.attr('data-disc-url'),
            type: 'POST',
            data: $form.serializeArray(),
            success: function (data) {
                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                    if (data["sessionChanged"] === true) {
                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                    }
                }

                if (data.hasOwnProperty('error') && data.hasOwnProperty('success') && data.hasOwnProperty('message')) {
                    if (data['error'] === true && data['success'] === false) {
                        if (data['birth_days_check'] === false) {
                            toastr.error(data['message']);

                            changePackFunc($form, function () {
                                var $form = $(document).find("form[name='app_conversion_path_second_step']");

                                calculateAjax($form, validateAjax);
                            });
                        } else {
                            toastr.error(data['message']);

                            $.ajax({
                                url: $form.attr('action') + '?chanpromo=true',
                                type: 'POST',
                                data: $form.serializeArray(),
                                success: function (html) {
                                    // $('#promo-code-birth-days').html($(html).find('#promo-code-birth-days').html());
                                    $('#promo-code-birth-days').fadeIn(0);
                                    $('#promo-code-birth-days input').prop('disabled', false);
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    if (jqXHR.status === 401) {
                                        window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                                    }
                                }
                            });
                        }
                    } else {
                        toastr.info(data['message']);
                        if (data['birth_days_check'] === false) {
                            // $('#promo-code-birth-days').html('');
                            $('#promo-code-birth-days').fadeOut(0);
                            $('#promo-code-birth-days input').prop('disabled', true);
                        }

                        changePackFunc($form, function () {
                            var $form = $(document).find("form[name='app_conversion_path_second_step']");

                            calculateAjax($form, validateAjax);
                        });
                    }
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401) {
                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                }
            }
        });
    });
}

if ($('.p__path--variant_ktg').length) {
    $(document).on("click", "#discount-ktg-button-submit", function (e) {
        var $form = $(this).closest('form');

        $.ajax({
            url: $form.attr('data-disc-url'),
            type: 'POST',
            data: $form.serializeArray(),
            success: function (data) {
                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                    if (data["sessionChanged"] === true) {
                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                    }
                }

                if (data.hasOwnProperty('error') && data.hasOwnProperty('success') && data.hasOwnProperty('message')) {
                    if (data['error'] === true && data['success'] === false) {
                        if (data['birth_days_check'] === false) {
                            toastr.error(data['message']);
                        } else {
                            toastr.error(data['message']);
                            $.ajax({
                                url: $form.attr('action') + '?chanpromo=true',
                                type: 'POST',
                                data: $form.serializeArray(),
                                success: function (html) {
                                    $('#promo-code-birth-days').html($(html).find('#promo-code-birth-days').html());
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    if (jqXHR.status === 401) {
                                        window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                                    }
                                }
                            });
                        }
                    } else {
                        toastr.info(data['message']);
                        if (data['birth_days_check'] === false) {
                            $('#promo-code-birth-days').html('');
                        }

                        $.when(changeKtgPackFunc($form)).done(function () {
                            var $form = $(document).find("form[name='app_ktg_path_first_step']");

                            calculateKtgAjax($form, validateAjax);
                        });
                    }
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401) {
                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                }
            }
        });
    });
}

var isLogged = false;

if ($('.p__path--second').length || $('.p--admin').length) {
    $(document).on("submit", "#second-step-login-form", function (e) {
        e.preventDefault();

        var $form = $(this).closest('form');

        if (isLogged === false) {
            $.ajax({
                url: $form.attr('action'),
                type: $form.attr('method'),
                data: $form.serializeArray(),
                success: function (data) {
                    if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                        if (data["sessionChanged"] === true) {
                            window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                        }
                    }

                    if (data.hasOwnProperty('success') && data.hasOwnProperty('errors') && data.hasOwnProperty('errorList')) {
                        if (data['success'] === false) {
                            isLogged = false;

                            formValidation($form.attr('name'), $.parseJSON(data['errorList']), null, false);

                            $(document).find('#invalid-credentials-error').remove();

                            if (data['errors'] !== '') {
                                $form.before("<div id='invalid-credentials-error' class='errorBar'>" +
                                    "<p>" + data['errors'] + "</p>" +
                                    "</div>");
                            }
                        } else {
                            isLogged = true;

                            if (data.hasOwnProperty('url')) {
                                window.location.href = Routing.generate(data['url'], {_locale: currentLocale,});
                            } else {
                                window.location.href = Routing.generate('app_conversion_path_third_step', {_locale: currentLocale,});
                            }
                        }
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    var data = jqXHR.responseJSON;

                    if (jqXHR.status === 401) {
                        isLogged = false;

                        formValidation($form.attr('name'), $.parseJSON(data['errorList']), null, false);

                        $(document).find('#invalid-credentials-error').remove();

                        if (data['errors'] !== '') {
                            $form.before("<div id='invalid-credentials-error' class='errorBar'><p>" + data['errors'] + "</p></div>");
                        }

                        // window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                    }
                },
                beforeSend: function (jqXHR, settings) {
                    isLogged = true;
                }
            });
        }
    });
}

var jqxhr_tsv;
// Walidacja trzeciego kroku
if ($('.p__path--third').length) {
    $(document).on("change", "form[name='app_conversion_path_third_step']", function (e) {
        var $form = $(this);
        var $element = $(e.target);
        var loader = $('.loader');

        if ($element.attr('id') === 'app_conversion_path_third_step_mother_pesel') {
            conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false, true);
        } else if ($element.attr('id') === 'app_conversion_path_third_step_mother_dateOfBirth') {
            conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false, true);
        } else if (e.target.id.indexOf('_phoneNumber_country') >= 0) {
            conversionPathThirdStepForm($form, $form.serializeArray(), e.target.id.replace('_phoneNumber_country', '_phoneNumber_number'), false);
        } else if ($element.attr('id') === 'app_conversion_path_third_step_isMother') {
            var $loader = $('.approval-statements .loader');

            $.when($.ajax({
                url: $form.attr('action') + '?chanmothda=true',
                type: $form.attr('method'),
                data: $form.serializeArray(),
                success: function (html) {
                    loader.fadeOut(600);
                    $('#mother-data-firstName').replaceWith($(html).find('#mother-data-firstName'));
                    $('#mother-data-lastName').replaceWith($(html).find('#mother-data-lastName'));
                    $('#mother-data-maidenName').replaceWith($(html).find('#mother-data-maidenName'));
                    $('#mother-data-address').replaceWith($(html).find('#mother-data-address'));
                    $('#mother-data-houseNumber').replaceWith($(html).find('#mother-data-houseNumber'));
                    $('#mother-data-placeNumber').replaceWith($(html).find('#mother-data-placeNumber'));
                    $('#mother-data-postalCode').replaceWith($(html).find('#mother-data-postalCode'));
                    $('#mother-data-city').replaceWith($(html).find('#mother-data-city'));
                    $('#mother-data-country').replaceWith($(html).find('#mother-data-country'));
                    $('#mother-data-dateOfBirth').replaceWith($(html).find('#mother-data-dateOfBirth'));
                    $('#mother-data-idNationalNumber').replaceWith($(html).find('#mother-data-idNationalNumber'));
                    $('#app_conversion_path_third_step_mother_country').select2();
                    $('#mother-data-pesel').replaceWith($(html).find('#mother-data-pesel'));
                    $('#mother-data-no-pesel').replaceWith($(html).find('#mother-data-no-pesel'));
                    $('#mother-data-idCard').replaceWith($(html).find('#mother-data-idCard'));
                    $('#mother-data-other-doc-type').replaceWith($(html).find('#mother-data-other-doc-type'));
                    $('#mother-data-other-doc-number').replaceWith($(html).find('#mother-data-other-doc-number'));
                    $('#mother-data-email').replaceWith($(html).find('#mother-data-email'));
                    $('#mother-data-phoneNumber').replaceWith($(html).find('#mother-data-phoneNumber'));
                    // $('#copyAddress').replaceWith($(html).find('#copyAddress'));
                    $('#app_conversion_path_third_step_mother_phoneNumber_country').select2();
                    if ($('#app_conversion_path_third_step_mother_phoneNumber_country').val() == 'PL') {
                        $('#app_conversion_path_third_step_mother_phoneNumber_country').closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
                    }
                    $('#address-for-correspondence-type').replaceWith($(html).find('#address-for-correspondence-type'));

                    $('.approval-statements').replaceWith($(html).find('.approval-statements'));
                    $('.approval-statements').find('input[type="checkbox"]:checked').each(function ($element) {
                        $(this).siblings('.switch').addClass('y');
                        $(this).siblings('span[data-answer="no"]').removeClass('active');
                        $(this).siblings('span[data-answer="yes"]').addClass('active');
                    });

                    if ($element.is(':checked')) {
                        $('#copyAddressMotherToChild').fadeIn(300);
                        $element.parent().find('.header-row').find('.checkbox-cancel').fadeIn(300);
                        initDatePicker();
                    } else {
                        $('#copyAddressMotherToChild').fadeOut(300);
                        $element.parent().find('.header-row').find('.checkbox-cancel').fadeOut(300);
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (jqXHR.status === 401) {
                        window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                    }
                }
            })).done(function () {
                var fieldsIds = [
                    'app_conversion_path_third_step_isMother',
                    'app_conversion_path_third_step_isFather'
                ];
                conversionPathThirdStepForm($form, $form.serializeArray(), fieldsIds, false);
            });
        } else if ($element.attr('id') === 'app_conversion_path_third_step_isFather') {
            var $loader = $('.approval-statements .loader');

            $.when($.ajax({
                url: $form.attr('action') + '?chanfathda=true',
                type: $form.attr('method'),
                data: $form.serializeArray(),
                success: function (html) {
                    loader.fadeOut(600);
                    $('#father-data-firstName').replaceWith($(html).find('#father-data-firstName'));
                    $('#father-data-lastName').replaceWith($(html).find('#father-data-lastName'));
                    $('#father-data-maidenName').replaceWith($(html).find('#father-data-maidenName'));
                    $('#father-data-address').replaceWith($(html).find('#father-data-address'));
                    $('#father-data-houseNumber').replaceWith($(html).find('#father-data-houseNumber'));
                    $('#father-data-placeNumber').replaceWith($(html).find('#father-data-placeNumber'));
                    $('#father-data-postalCode').replaceWith($(html).find('#father-data-postalCode'));
                    $('#father-data-city').replaceWith($(html).find('#father-data-city'));
                    $('#father-data-country').replaceWith($(html).find('#father-data-country'));
                    $('#father-data-dateOfBirth').replaceWith($(html).find('#father-data-dateOfBirth'));
                    $('#father-data-idNationalNumber').replaceWith($(html).find('#father-data-idNationalNumber'));
                    $('#app_conversion_path_third_step_father_country').select2();
                    $('#father-data-pesel').replaceWith($(html).find('#father-data-pesel'));
                    $('#father-data-no-pesel').replaceWith($(html).find('#father-data-no-pesel'));
                    $('#father-data-idCard').replaceWith($(html).find('#father-data-idCard'));
                    $('#father-data-other-doc-type').replaceWith($(html).find('#father-data-other-doc-type'));
                    $('#father-data-other-doc-number').replaceWith($(html).find('#father-data-other-doc-number'));
                    $('#father-data-email').replaceWith($(html).find('#father-data-email'));
                    $('#father-data-phoneNumber').replaceWith($(html).find('#father-data-phoneNumber'));
                    // $('#copyAddress').replaceWith($(html).find('#copyAddress'));
                    $('#app_conversion_path_third_step_father_phoneNumber_country').select2();
                    if ($('#app_conversion_path_third_step_father_phoneNumber_country').val() == 'PL') {
                        $('#app_conversion_path_third_step_father_phoneNumber_country').closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
                    }
                    $('#address-for-correspondence-type').replaceWith($(html).find('#address-for-correspondence-type'));

                    $('.approval-statements').replaceWith($(html).find('.approval-statements'));
                    $('.approval-statements').find('input[type="checkbox"]:checked').each(function ($element) {
                        $(this).siblings('.switch').addClass('y');
                        $(this).siblings('span[data-answer="no"]').removeClass('active');
                        $(this).siblings('span[data-answer="yes"]').addClass('active');
                    });

                    if ($element.is(':checked')) {
                        $('#copyAddressFatherToChild').fadeIn(300);
                        $element.parent().find('.header-row').find('.checkbox-cancel').fadeIn(300);
                        initDatePicker();
                    } else {
                        $('#copyAddressFatherToChild').fadeOut(300);
                        $element.parent().find('.header-row').find('.checkbox-cancel').fadeOut(300);
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (jqXHR.status === 401) {
                        window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                    }
                }
            })).done(function () {
                var fieldsIds = [
                    'app_conversion_path_third_step_isMother',
                    'app_conversion_path_third_step_isFather'
                ];
                conversionPathThirdStepForm($form, $form.serializeArray(), fieldsIds, false);
            });
        } else if ($element.attr('id') === 'app_conversion_path_third_step_child_dateOfBirth') {
            conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
        } else if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData_childBirthNumber') {
            var childBirthNumber = parseInt($element.val());
            var pregnancyNumber = parseInt($('#app_conversion_path_third_step_childbirthData_pregnancyNumber').val());

            if (childBirthNumber <= pregnancyNumber) {
                if (pregnancyNumber - childBirthNumber >= 2) {
                    $('.lightboxAccept').fadeIn(300);
                    $('[data=closeLightbox]').on('click', function () {
                        $('.lightboxAccept').fadeOut(300);
                    });
                }
            }

            conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
        } else if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData_pregnancyNumber') {
            var childBirthNumber = parseInt($('#app_conversion_path_third_step_childbirthData_childBirthNumber').val());
            var pregnancyNumber = parseInt($element.val());

            if (childBirthNumber <= pregnancyNumber) {
                if (pregnancyNumber - childBirthNumber >= 2) {
                    $('.lightboxAccept').fadeIn(300);
                    $('[data=closeLightbox]').on('click', function () {
                        $('.lightboxAccept').fadeOut(300);
                    });
                }
            }

            conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
        } else if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData__hospital') {
            $.when(changeOtherHospital($element, 'first', false)).done(function () {
                conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
            });
        } else if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData__secondHospital') {
            $.when(changeOtherHospital($element, 'second', false)).done(function () {
                conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
            });
        } else if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData_firstOtherHospitalName') {
            $.when(changeOtherHospital($element, 'first', true)).done(function () {
                conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
            });
        } else if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData_firstOtherHospitalAddress') {
            $.when(changeOtherHospital($element, 'first', true)).done(function () {
                conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
            });
        } else if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData_secondOtherHospitalName') {
            $.when(changeOtherHospital($element, 'second', true)).done(function () {
                conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
            });
        } else if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData_secondOtherHospitalAddress') {
            $.when(changeOtherHospital($element, 'second', true)).done(function () {
                conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
            });
        } else if (e.target.id.indexOf('app_conversion_path_third_step_isKit_') >= 0) {
            $('.kitCont .loader').fadeIn(300);
            $.when(changeKit($element)).done(function () {
                conversionPathThirdStepForm($form, $form.serializeArray(), 'app_conversion_path_third_step_isKit', false);
            });
        } else if (e.target.id.indexOf('app_conversion_path_third_step_addressForCorrespondenceType_') >= 0) {
            conversionPathThirdStepForm($form, $form.serializeArray(), 'app_conversion_path_third_step_addressForCorrespondenceType', false);
        } else if (e.target.id.indexOf('app_conversion_path_third_step_kitNumbers_') >= 0) {
            var ids = [];

            $(document).find('input[id^=app_conversion_path_third_step_kitNumbers_]').each(function () {
                if ($(this).val() !== '') {
                    ids.push($(this).attr('id'));
                }
            });
            $('.kitCont .loader').fadeIn(300);
            $.when(conversionPathThirdStepForm($form, $form.serializeArray(), ids, false)).done(function () {
                $('.kitCont .loader').fadeOut(300);
            });
        } else if (e.target.id.indexOf('app_conversion_path_third_step__pregnancyData_authorizedPeople_') >= 0) {
            var ids = [];
            var allEmpty = true;

            $(document).find('input[id^=app_conversion_path_third_step__pregnancyData_authorizedPeople_' + $element.attr('loop-index') + ']').each(function () {
                if ($(this).val() !== '') {
                    allEmpty = false;
                }
            });

            $(document).find('input[id^=app_conversion_path_third_step__pregnancyData_authorizedPeople_' + $element.attr('loop-index') + ']').each(function () {
                if (allEmpty === true) {
                    ids.push($(this).attr('id'));
                } else {
                    if ($element.attr('id') === $(this).attr('id')) {
                        ids.push($(this).attr('id'));
                    } else {
                        if ($(this).val() !== '') {
                            ids.push($(this).attr('id'));
                        }
                    }
                }
            });

            conversionPathThirdStepForm($form, $form.serializeArray(), ids, false);
        } else if (e.target.id.indexOf('app_conversion_path_third_step__agreements_') >= 0) {
            if (jqxhr_tsv) {
                jqxhr_tsv.abort();
            }

            $.when(jqxhr_tsv = $.ajax({
                url: $form.attr('action') + '?chanagr=true',
                type: $form.attr('method'),
                data: $form.serializeArray(),
                success: function (html) {
                    $('.approval-statements').replaceWith($(html).find('.approval-statements'));
                    $('.approval-statements').find('input[type="checkbox"]:checked').each(function ($element) {
                        $(this).siblings('.switch').addClass('y');
                        $(this).siblings('span[data-answer="no"]').removeClass('active');
                        $(this).siblings('span[data-answer="yes"]').addClass('active');
                    });
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (jqXHR.status === 401) {
                        window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                    }
                }
            })).done(function () {
                conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
            });
        } else {
            conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
        }

        if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData_dateOfBirth') {
            var ktgEnd = new Date('2018-08-31');
            var isKtgAttr = parseInt($element.attr('data-is-ktg'));
            var now = new Date();
            var selected = new Date($element.val());

            var timeDiff = Math.abs(selected.getTime() - now.getTime());
            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

            if (diffDays <= 5) {
                toastr.info(jsTranslations['messages']['soon_birthdate_warning']);
            }

            if (isKtgAttr === 1) {
                if (selected.getTime() > ktgEnd.getTime()) {
                    toastr.error(jsTranslations['messages']['birthdate_before_only']);
                }
            }
        }
    });

    $(document).on("click", "#conversion_path_submit", function (e) {
        var $form = $(this).closest('form');

        conversionPathThirdStepForm($form, $form.serializeArray(), null, true);
    });

    var changeOtherHospital = function ($element, number, onlyAgreements) {
        var $form = $element.closest('form');
        var $loader = $('.approval-statements .loader');
        $loader.fadeIn(300);
        $.ajax({
            url: $form.attr('action') + '?chanhosp=true',
            type: $form.attr('method'),
            data: $form.serializeArray(),
            success: function (html) {
                if (onlyAgreements === false) {
                    $('#' + number + '_other_hospital').replaceWith($(html).find('#' + number + '_other_hospital'));
                }

                $('.approval-statements').replaceWith($(html).find('.approval-statements'));
                $('.approval-statements').find('input[type="checkbox"]:checked').each(function ($element) {
                    $(this).siblings('.switch').addClass('y');
                    $(this).siblings('span[data-answer="no"]').removeClass('active');
                    $(this).siblings('span[data-answer="yes"]').addClass('active');
                });
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401) {
                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                }
            }
        });
    };

    var changeKit = function ($element) {
        var $form = $element.closest('form');

        $.ajax({
            url: $form.attr('action') + '?chankit=true',
            type: $form.attr('method'),
            data: $form.serializeArray(),
            success: function (html) {
                $('#kitNumbers').replaceWith($(html).find('#kitNumbers'));
                $('#kitAddress').replaceWith($(html).find('#kitAddress'));
                $('#kitAddress .countrySelect').select2();
                if ($('#kitAddress .countrySelect').val() == 'PL') {
                    $('#kitAddress .countrySelect').closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
                }
                $('.loader').fadeOut(300);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401) {
                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                }
            }
        });
    };

    $(document).on('click', '.checkbox-cancel', function () {
        $(this).parent().next().click().trigger('change');
    });

    // $(document).on("change", "#app_conversion_path_third_step__familyData__childbirthData__hospital", function (e) {
    //     changeOtherHospital($(this), 'first');
    // });
    //
    // $(document).on("change", "#app_conversion_path_third_step__familyData__childbirthData__secondHospital", function (e) {
    //     changeOtherHospital($(this), 'second');
    // });
}

// Walidacja czwartego kroku
if ($('.p__path--fourth').length) {

    var $inputDisease = $('[data-section] input[data-disease]');

    $inputDisease.on('change', function () {
        var data = $(this).attr('data-disease');
        var dataCount = $(this).attr('data-count');
        var answer = $(this).attr('data-answer');
        var found = $('form[name=app_conversion_path_fourth_step] input[data-disease="' + data + '"][data-answer="' + answer + '"]');
        if (dataCount == 'misc') {

        } else {
            found.trigger("change");
        }

        // $(this).prop("checked", true);
    });

    $(document).on("change", "form[name='app_conversion_path_fourth_step']", function (e) {
        var $form = $(this);
        var $element = $(e.target);
        var elementId = $element.attr('id');
        var elementAnswerId = '';

        if (typeof elementId !== 'undefined') {
            if (elementId.indexOf('_answer') === -1) {
                elementId = elementId.slice(0, -2);
                elementAnswerId = elementId + '_answer';
            } else {
                elementAnswerId = elementId;
                elementId = elementId.slice(0, -7);
            }

            var ids = [elementId, elementAnswerId];

            if ($.inArray(elementId, ['app_conversion_path_fourth_step_f5d4fb72', 'app_conversion_path_fourth_step_ea52e2aa', 'app_conversion_path_fourth_step_d34c1686']) !== -1) {
                ids.push('app_conversion_path_fourth_step_bbe80691')
            }

            $('#app_conversion_path_fourth_step__timestamp').val(Date.now());

            conversionPathFourthStepForm($form, $form.serializeArray(), ids, false);
        }
    });

    $(document).on("click", "#conversion_path_submit", function (e) {
        var $form = $(this).closest('form');

        $('#app_conversion_path_fourth_step__timestamp').val(Date.now());

        conversionPathFourthStepForm($form, $form.serializeArray(), null, true);
    });
}

// Walidacja piątego kroku
if ($('.p__path--fifth').length) {
    $(document).on("change", "form[name='app_conversion_path_fifth_step']", function (e) {
        var $form = $(this);
        var $element = $(e.target);
        var $button = $('#conversion_path_submit');

        if ($element[0].id === 'app_conversion_path_fifth_step_paymentMethod_1') {
            $button.html(jsTranslations['messages']['order_payment_later'] + ' <i class="fa fa-angle-right" aria-hidden="true"></i>');
        }

        if ($element[0].id === 'app_conversion_path_fifth_step_paymentMethod_0') {
            $button.html(jsTranslations['messages']['order_payment_now'] + ' <i class="fa fa-angle-right" aria-hidden="true"></i>');
        }

        conversionPathForm($form, $form.serializeArray(), $element.attr('id'), false);
    });

    $(document).on("click", "#conversion_path_submit", function (e) {
        var $form = $(this).closest('form');
        $('.btn--back').hide();

        conversionPathForm($form, $form.serializeArray(), null, true);
    });
}

var jqxhr_kpf;
var ktgPathForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_kpf) {
        jqxhr_kpf.abort();
    }
    jqxhr_kpf = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('newAccount') && data.hasOwnProperty('url')) {
                $.ajax({
                    url: $form.attr('data-acco-url'),
                    type: "GET",
                    success: function (data) {
                        if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                            if (data["sessionChanged"] === true) {
                                window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                            }
                        }

                        $(".p__path--variant_ktg").append(data);
                        $('body').addClass('unscroll');
                        $('.countrySelect').each(function () {
                            $(this).select2();
                            if ($(this).val() == 'PL') {
                                $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
                            }
                        });

                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        if (jqXHR.status === 401) {
                            window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                        }
                    }
                });
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};

// Walidacja pierwszego kroku KTG
if ($('.p__path--variant_ktg').length || $('.p__path--fifth').length) {
    $(document).on("change", "form[name='app_ktg_path_first_step']", function (e) {
        if (e.target.id !== 'app_ktg_path_first_step_promoCode') {
            var $form = $(this);
            var $element = $(e.target);

            if (e.target.id.indexOf('app_ktg_path_first_step__ktgPackage_') >= 0) {
                ktgPathForm($form, $form.serializeArray(), 'app_ktg_path_first_step__ktgPackage', false);
            } else {
                ktgPathForm($form, $form.serializeArray(), $element.attr('id'), false);
            }
        }
    });

    $(document).on("click", "#ktg_path_submit", function (e) {
        var $form = $(this).closest('form');

        ktgPathForm($form, $form.serializeArray(), null, true);
    });

    $(document).on("click", "#first-step-account-btn", function (e) {
        var $form = $(this).closest('form');

        accountForm($form, $form.serializeArray(), null, true);
    });

    $(document).on("click", "#first-step-back-account-btn", function (e) {
        e.preventDefault();

        var $form = $(this).closest('form');

        $.ajax({
            url: $form.attr('data-acc-url'),
            type: "GET",
            success: function (data) {
                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                    if (data["sessionChanged"] === true) {
                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                    }
                }

                $('.lightbox_wrapper[indirect-step]').remove();
                $('body').addClass('unscroll');
                $(".p__path--variant_ktg").append(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401) {
                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                }
            }
        });
    });

    $(document).on("click", "#first-step-login-btn", function (e) {
        $.ajax({
            url: Routing.generate('app_ktg_path_first_step_login', {_locale: currentLocale,}),
            type: 'GET',
            success: function (data) {
                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                    if (data["sessionChanged"] === true) {
                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                    }
                }

                $('.lightbox_wrapper').remove();
                $(".p__path--variant_ktg").append(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401) {
                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                }
            }
        });
    });

    var isLoggedKtg = false;

    $(document).on("submit", "#first-step-login-form", function (e) {
        e.preventDefault();

        var $form = $(this).closest('form');

        if (isLoggedKtg === false) {
            $.ajax({
                url: $form.attr('action'),
                type: $form.attr('method'),
                data: $form.serializeArray(),
                success: function (data) {
                    if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                        if (data["sessionChanged"] === true) {
                            window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                        }
                    }

                    if (data.hasOwnProperty('success') && data.hasOwnProperty('errors') && data.hasOwnProperty('errorList')) {
                        if (data['success'] === false) {
                            isLoggedKtg = false;

                            formValidation($form.attr('name'), $.parseJSON(data['errorList']), null, false);

                            $(document).find('#invalid-credentials-error').remove();

                            if (data['errors'] !== '') {
                                $form.before("<div id='invalid-credentials-error' class='errorBar'><p>" + data['errors'] + "</p></div>");
                            }
                        } else {
                            isLoggedKtg = true;

                            if (data.hasOwnProperty('url')) {
                                window.location.href = Routing.generate(data['url'], {_locale: currentLocale,});
                            } else {
                                window.location.href = Routing.generate('app_ktg_path_second_step', {_locale: currentLocale,});
                            }
                        }
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    var data = jqXHR.responseJSON;

                    if (jqXHR.status === 401) {
                        isLoggedKtg = false;

                        formValidation($form.attr('name'), $.parseJSON(data['errorList']), null, false);

                        $(document).find('#invalid-credentials-error').remove();

                        if (data['errors'] !== '') {
                            $form.before("<div id='invalid-credentials-error' class='errorBar'><p>" + data['errors'] + "</p></div>");
                        }

                        // window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                    }
                },
                beforeSend: function (jqXHR, settings) {
                    isLoggedKtg = true;
                }
            });
        }
    });

    var loader = $('.loader');

    var calculateKtgAjax = function ($form, callback) {
        if (jqxhr) {
            jqxhr.abort();
        }
        loader.fadeIn(100);
        jqxhr = $.ajax({
            url: $form.attr('data-calc-url'),
            type: "POST",
            data: $form.serialize(),
            success: function (data) {
                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                    if (data["sessionChanged"] === true) {
                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                    }
                }

                // ceny
                for (var propPackage in data.packages) {
                    if (propPackage === data.selected) {
                        if (data.packages[propPackage].fees.hasOwnProperty('base_ktg')) {
                            for (var propKtg in data.packages[propPackage].fees.base_ktg['client_price']) {
                                $("#base_ktg_" + propKtg.replace(".", "\\.")).html((data.packages[propPackage].fees.base_ktg['client_price'][propKtg] / 100) + ' euro');
                                $("[data='" + propKtg.replace(".", "\\.") + "']").attr('dataPrice', (data.packages[propPackage].fees.base_ktg['client_price'][propKtg] / 100)).trigger("ktgPriceChange");
                            }
                        }
                    }
                }

                if (data.hasOwnProperty('discounts')) {
                    if (data['discounts']['type'] === 'code') {
                        $("#discount-checked").addClass('active').html('Aktywowałeś kod promocyjny');
                    }
                }

                if (data.hasOwnProperty('discounts')) {
                    if (data['discounts']['error'] === false && data['discounts']['success'] === true) {
                        $(".expire-date").removeClass('active');
                    } else if (data['discounts']['error'] === true && data['discounts']['success'] === false) {
                        if (data['discounts'].hasOwnProperty('message')) {
                            $(".expire-date").html(data['discounts']['message']);
                        } else {
                            $(".expire-date").html('Podany kod stracił ważność');
                        }


                    } else {
                        $(".expire-date").removeClass('active');
                    }
                } else {
                    $(".expire-date").removeClass('active');
                }

                loader.fadeOut(100);

                // callback($form);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401) {
                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                }
            }
        });
        return jqxhr;
    };
}

// Walidacja drugiego kroku KTG
if ($('.p__path-ktg--second').length) {
    $(document).on("change", "form[name='app_ktg_path_second_step']", function (e) {
        var $form = $(this);
        var $element = $(e.target);
        var ids = [];
        var allEmpty = true;

        var loader = $('.loader');

        if (e.target.id.indexOf('app_ktg_path_second_step_pregnancyData_authorizedPeople_') >= 0) {
            $(document).find('input[id^=app_ktg_path_second_step_pregnancyData_authorizedPeople_' + $element.attr('loop-index') + ']').each(function () {
                if ($(this).val() !== '') {
                    allEmpty = false;
                }
            });

            $(document).find('input[id^=app_ktg_path_second_step_pregnancyData_authorizedPeople_' + $element.attr('loop-index') + ']').each(function () {
                if (allEmpty === true) {
                    ids.push($(this).attr('id'));
                } else {
                    if ($element.attr('id') === $(this).attr('id')) {
                        ids.push($(this).attr('id'));
                    } else {
                        if ($(this).val() !== '') {
                            ids.push($(this).attr('id'));
                        }
                    }
                }
            });

            ktgPathForm($form, $form.serializeArray(), ids, false);
        } else if ($element.attr('id') === 'app_ktg_path_second_step_isKtgDevice') {
            $('.ktgCont .loader').fadeIn(300);
            $.when($.ajax({
                url: $form.attr('action') + '?chanktgd=true',
                type: $form.attr('method'),
                data: $form.serializeArray(),
                success: function (html) {

                    $('#ktgAddress').replaceWith($(html).find('#ktgAddress'));
                    $('#ktgAddress').find('input').each(function () {
                        $(this).val('');
                    });
                    $('#ktgAddress .countrySelect').select2();
                    $('.ktgCont .loader').fadeOut(300);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (jqXHR.status === 401) {
                        window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                    }
                }
            })).done(function () {
                ktgPathForm($form, $form.serializeArray(), $element.attr('id'), false);
            });
        } else {
            ktgPathForm($form, $form.serializeArray(), $element.attr('id'), false);
        }

        if ($element.attr('id') === 'app_ktg_path_second_step_pregnancyData_dateOfBirth') {
            var ktgEnd = new Date('2018-08-31');
            var selected = new Date($element.val());
            var isKtgAttr = parseInt($element.attr('data-is-ktg'));

            if (isKtgAttr === 1) {
                if (selected.getTime() > ktgEnd.getTime()) {
                    toastr.error(jsTranslations['messages']['birthdate_before_only']);
                }
            }
        }
    });

    $(document).on("click", "#ktg_path_submit", function (e) {
        var $form = $(this).closest('form');

        ktgPathForm($form, $form.serializeArray(), null, true);
    });
}

// Walidacja trzeciego kroku KTG
if ($('.p__path-ktg--third').length) {
    $(document).on("change", "form[name='app_ktg_path_third_step']", function (e) {
        var $form = $(this);
        var $element = $(e.target);

        if (e.target.id.indexOf('app_ktg_path_third_step_paymentMethod_') >= 0) {
            ktgPathForm($form, $form.serializeArray(), 'app_ktg_path_third_step_paymentMethod', false);
        }
    });

    $(document).on("click", "#ktg_path_submit", function (e) {
        var $form = $(this).closest('form');

        ktgPathForm($form, $form.serializeArray(), null, true);
    });
}

var jqxhr_ucef;
var iactUserChangeEmailForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_ucef) {
        jqxhr_ucef.abort();
    }
    jqxhr_ucef = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
                auth(data['mfaUrl']);
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};

var jqxhr_ucpf;
var iactUserChangePasswordForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_ucpf) {
        jqxhr_ucpf.abort();
    }
    jqxhr_ucpf = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
                auth(data['mfaUrl']);
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }

        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};

var jqxhr_ucpnf;
var iactUserChangePhoneNumberForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_ucpnf) {
        jqxhr_ucpnf.abort();
    }
    jqxhr_ucpnf = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
                auth(data['mfaUrl']);
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};

var jqxhr_uccf;
var iactUserChangeContactForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_uccf) {
        jqxhr_uccf.abort();
    }
    jqxhr_uccf = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
                auth(data['mfaUrl']);
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};

var jqxhr_iuccf;
var iactUserContractChildForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_iuccf) {
        jqxhr_iuccf.abort();
    }
    jqxhr_iuccf = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
                auth(data['mfaUrl']);
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};

var jqxhr_iucccf;
var iactUserContractChildChangeForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_iucccf) {
        jqxhr_iucccf.abort();
    }
    jqxhr_iucccf = $.ajax({
        url: $form.attr('action') + '?cNoPesel=true',
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            $form.find('div[data-pesel="true"]').replaceWith($(data).find('div[data-pesel="true"]'));
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};

var jqxhr_iuddf;
var iactUserDocumentDownloadForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_iuddf) {
        jqxhr_iuddf.abort();
    }
    jqxhr_iuddf = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
                auth(data['mfaUrl']);
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};

// Walidacja ustawień klienta
if ($('.tile.settings').length) {
    // Walidacja zmiany emaila
    $(document).on("click", "#iact_user_change_email_submit", function (e) {
        var $form = $(this).closest('form');
        iactUserChangeEmailForm($form, $form.serializeArray(), null, true);
    });
    $(document).find("form[name='iact_user_change_email']").keypress(function (e) {
        if (e.which == '13') {
            e.preventDefault();

            var $form = $(document).find("form[name='iact_user_change_email']");
            iactUserChangeEmailForm($form, $form.serializeArray(), null, true);
        }
    });

    // Walidacja zmiany hasła
    $(document).on("change", "form[name='iact_user_change_password']", function (e) {
        var $form = $(this);
        var $element = $(e.target);
        var ids = [];

        if ($element.attr('id').indexOf('currentPassword') !== -1) {
            iactUserChangePasswordForm($form, $form.serializeArray(), $element.attr('id'), false);
        } else {
            if ($element.attr('id').indexOf('first') === -1) {
                if ($('#' + $element.attr('id')).val() !== '') {
                    ids.push($element.attr('id'));
                }

                if ($('#' + $element.attr('id').slice(0, -6) + 'first').val() !== '') {
                    ids.push($element.attr('id').slice(0, -6) + 'first');
                }
            } else {
                if ($('#' + $element.attr('id')).val() !== '') {
                    ids.push($element.attr('id'));
                }

                if ($('#' + $element.attr('id').slice(0, -5) + 'second').val() !== '') {
                    ids.push($element.attr('id').slice(0, -5) + 'second');
                }
            }

            if (ids.length === 2) {
                iactUserChangePasswordForm($form, $form.serializeArray(), ids, false);
            }
        }
    });
    $(document).on("click", "#iact_user_change_password_submit", function (e) {
        var $form = $(this).closest('form');
        iactUserChangePasswordForm($form, $form.serializeArray(), null, true);
    });

    // Walidacja zmiany numeru telefonu
    $(document).on("click", "#iact_user_change_phone_number_submit", function (e) {
        var $form = $(this).closest('form');
        iactUserChangePhoneNumberForm($form, $form.serializeArray(), null, true);
    });
    $(document).find("form[name='change_phone_number']").keypress(function (e) {
        if (e.which == '13') {
            e.preventDefault();

            var $form = $(document).find("form[name='change_phone_number']");
            iactUserChangePhoneNumberForm($form, $form.serializeArray(), null, true);
        }
    });
}

if ($('.p__dashboard').length) {
    // Walidacja zmiany danych kontaktowych
    $(document).on("change", "form[name='app_account_contact']", function (e) {
        var $form = $(this);
        if (e.target.id.indexOf('_phoneNumber_country') >= 0) {
            iactUserChangeContactForm($form, $form.serializeArray(), e.target.id.replace('_phoneNumber_country', '_phoneNumber_number'), false);
        } else {
            iactUserChangeContactForm($form, $form.serializeArray(), e.target.id, false);
        }
    });
    $(document).on("click", "#iact_user_change_contact_submit", function (e) {
        var $form = $(this).closest('form');
        iactUserChangeContactForm($form, $form.serializeArray(), null, true);
    });

    // Walidacja zmiany danych dziecka
    $(document).on("click", "#iact_user_contract_child_submit", function (e) {
        var $form = $(this).closest('form');
        iactUserContractChildForm($form, $form.serializeArray(), null, true);
    });
    $(document).on("change", 'form[name="app_account_child"]', function (e) {
        var $form = $(this).closest('form');

        if (e.target.id === 'app_account_child_noPesel') {
            iactUserContractChildChangeForm($form, $form.serializeArray(), null, true);
        }
    });

    $(document).on("click", "button[data-doc-down-sec='true']", function (e) {
        var $form = $(this).closest('form');
        iactUserDocumentDownloadForm($form, $form.serializeArray(), null, true);
    });
}

function auth(url) {
    $.ajax({
        url: url,
        type: "GET",
        success: function (data, textStatus, jqXHR) {
            $("#mfa").html(data);
            $("#mfa").find("form[name='iact_core_mfa']").keypress(function (e) {
                if (e.which == '13') {
                    e.preventDefault();

                    var $form = $("#mfa").find("form[name='iact_core_mfa']");

                    iactCoreMfaForm($form, $form.serializeArray(), null, $form.attr('data-form'));
                }
            });
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
}

var jqxhr_icmlf;
var iactCoreMfaLoginForm = function ($form, params, fieldId) {
    if (jqxhr_icmlf) {
        jqxhr_icmlf.abort();
    }
    jqxhr_icmlf = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (data.hasOwnProperty("success") && data["success"] === true) {
                $form.submit();
            } else {
                formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, false);
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};

$(document).on("click", "#iact_core_mfa_login_submit", function (event) {
    var $form = $(this).closest('form');

    iactCoreMfaLoginForm($form, $form.serializeArray(), null);
});

var jqxhr_icmf;
var iactCoreMfaForm = function ($form, params, fieldId, formId) {
    if (jqxhr_icmf) {
        jqxhr_icmf.abort();
    }
    jqxhr_icmf = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (data.hasOwnProperty("success") && data["success"] === true) {
                if ($(document).find('div[data-results-page="true"]').length > 0) {
                    $('.lightbox_wrapper').remove();
                    toastr.info(jsTranslations['messages']['collection_started']);
                }

                $("#" + formId).submit();
            } else {
                formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, false);
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};

$(document).on("click", "#iact_core_mfa_submit", function (event) {
    var $form = $(this).closest('form');

    iactCoreMfaForm($form, $form.serializeArray(), null, $form.attr('data-form'));
});

$(document).find("form[name='iact_core_mfa']").keypress(function (e) {
    if (e.which == '13') {
        e.preventDefault();

        var $form = $(this).closest('form');

        iactCoreMfaLoginForm($form, $form.serializeArray(), null);
    }
});

var jqxhr_iprpf;
var iactPartnerRegistrationPasswordForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_iprpf) {
        jqxhr_iprpf.abort();
    }
    jqxhr_iprpf = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
                auth(data['mfaUrl']);
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_partner_security_login', {_locale: currentLocale,});
            }
        }
    });
};
$(document).on("change", "form[name='iact_partner_registration_password']", function (e) {
    var $form = $(this);
    var $element = $(e.target);
    var ids = [];

    if ($element.attr('id').indexOf('first') === -1) {
        if ($('#' + $element.attr('id')).val() !== '') {
            ids.push($element.attr('id'));
        }

        if ($('#' + $element.attr('id').slice(0, -6) + 'first').val() !== '') {
            ids.push($element.attr('id').slice(0, -6) + 'first');
        }
    } else {
        if ($('#' + $element.attr('id')).val() !== '') {
            ids.push($element.attr('id'));
        }

        if ($('#' + $element.attr('id').slice(0, -5) + 'second').val() !== '') {
            ids.push($element.attr('id').slice(0, -5) + 'second');
        }
    }

    if (ids.length === 2) {
        iactPartnerRegistrationPasswordForm($form, $form.serializeArray(), ids, false);
    }
});
$(document).on("click", "#iact_partner_registration_password_submit", function (e) {
    var $form = $(this).closest('form');

    iactPartnerRegistrationPasswordForm($form, $form.serializeArray(), null, true);
});

var jqxhr_iprrf;
var iactPartnerResetRequestForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_iprrf) {
        jqxhr_iprrf.abort();
    }
    jqxhr_iprrf = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
                auth(data['mfaUrl']);
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_partner_security_login', {_locale: currentLocale,});
            }
        }
    });
};
$(document).on("change", "form[name='iact_partner_resetting_request']", function (e) {
    var $form = $(this).closest('form');

    iactPartnerResetRequestForm($form, $form.serializeArray(), e.target.id, false);
});
$(document).on("click", "#iact_partner_reset_request_submit", function (e) {
    var $form = $(this).closest('form');

    iactPartnerResetRequestForm($form, $form.serializeArray(), null, true);
});
$(document).find("form[name='iact_partner_resetting_request']").keypress(function (e) {
    if (e.which == '13') {
        e.preventDefault();

        var $form = $(this).closest('form');

        iactPartnerResetRequestForm($form, $form.serializeArray(), null, true);
    }
});

var jqxhr_iprspf;
var iactPartnerResetPasswordForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_iprspf) {
        jqxhr_iprspf.abort();
    }
    jqxhr_iprspf = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
                auth(data['mfaUrl']);
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_partner_security_login', {_locale: currentLocale,});
            }
        }
    });
};
$(document).on("change", "form[name='iact_partner_resetting_password']", function (e) {
    var $form = $(this).closest('form');
    var $element = $(e.target);
    var ids = [];

    if ($element.attr('id').indexOf('first') === -1) {
        if ($('#' + $element.attr('id')).val() !== '') {
            ids.push($element.attr('id'));
        }

        if ($('#' + $element.attr('id').slice(0, -6) + 'first').val() !== '') {
            ids.push($element.attr('id').slice(0, -6) + 'first');
        }
    } else {
        if ($('#' + $element.attr('id')).val() !== '') {
            ids.push($element.attr('id'));
        }

        if ($('#' + $element.attr('id').slice(0, -5) + 'second').val() !== '') {
            ids.push($element.attr('id').slice(0, -5) + 'second');
        }
    }

    if (ids.length === 2) {
        iactPartnerResetPasswordForm($form, $form.serializeArray(), ids, false);
    }
});
$(document).on("click", "#iact_partner_reset_password_submit", function (e) {
    var $form = $(this).closest('form');

    iactPartnerResetPasswordForm($form, $form.serializeArray(), null, true);
});

var jqxhr_iurpf;
var iactUserRegistrationPasswordForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_iurpf) {
        jqxhr_iurpf.abort();
    }
    jqxhr_iurpf = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
                auth(data['mfaUrl']);
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};
$(document).on("change", "form[name='iact_user_registration_password']", function (e) {
    var $form = $(this);
    var $element = $(e.target);
    var ids = [];

    if ($element.attr('id').indexOf('first') === -1) {
        if ($('#' + $element.attr('id')).val() !== '') {
            ids.push($element.attr('id'));
        }

        if ($('#' + $element.attr('id').slice(0, -6) + 'first').val() !== '') {
            ids.push($element.attr('id').slice(0, -6) + 'first');
        }
    } else {
        if ($('#' + $element.attr('id')).val() !== '') {
            ids.push($element.attr('id'));
        }

        if ($('#' + $element.attr('id').slice(0, -5) + 'second').val() !== '') {
            ids.push($element.attr('id').slice(0, -5) + 'second');
        }
    }

    if (ids.length === 2) {
        iactUserRegistrationPasswordForm($form, $form.serializeArray(), ids, false);
    }
});
$(document).on("click", "#iact_user_registration_password_submit", function (e) {
    var $form = $(this).closest('form');

    iactUserRegistrationPasswordForm($form, $form.serializeArray(), null, true);
});

var jqxhr_iursrf;
var iactUserResetRequestForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_iursrf) {
        jqxhr_iursrf.abort();
    }
    jqxhr_iursrf = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
                auth(data['mfaUrl']);
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};
$(document).on("change", "form[name='iact_user_resetting_request']", function (e) {
    var $form = $(this);

    iactUserResetRequestForm($form, $form.serializeArray(), e.target.id, false);
});
$(document).on("click", "#iact_user_reset_request_submit", function (e) {
    var $form = $(this).closest('form');

    iactUserResetRequestForm($form, $form.serializeArray(), null, true);
});
$(document).find("form[name='iact_user_resetting_request']").keypress(function (e) {
    if (e.which == '13') {
        e.preventDefault();

        var $form = $(this).closest('form');

        iactUserResetRequestForm($form, $form.serializeArray(), null, true);
    }
});

var jqxhr_iuopof;
var iactUserOfferPathOrderForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_iuopof) {
        jqxhr_iuopof.abort();
    }
    jqxhr_iuopof = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
                auth(data['mfaUrl']);
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};
$(document).on("click", "#iact_user_offer_path_order_submit", function (e) {
    var $form = $(this).closest('form');

    iactUserOfferPathOrderForm($form, $form.serializeArray(), "interactivo_path_order_pathOrder", true);
});

var jqxhr_iurspf;
var iactUserResetPasswordForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_iurspf) {
        jqxhr_iurspf.abort();
    }
    jqxhr_iurspf = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
                auth(data['mfaUrl']);
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};
$(document).on("change", "form[name='iact_user_resetting_password']", function (e) {
    var $form = $(this);
    var $element = $(e.target);
    var ids = [];

    if ($element.attr('id').indexOf('first') === -1) {
        if ($('#' + $element.attr('id')).val() !== '') {
            ids.push($element.attr('id'));
        }

        if ($('#' + $element.attr('id').slice(0, -6) + 'first').val() !== '') {
            ids.push($element.attr('id').slice(0, -6) + 'first');
        }
    } else {
        if ($('#' + $element.attr('id')).val() !== '') {
            ids.push($element.attr('id'));
        }

        if ($('#' + $element.attr('id').slice(0, -5) + 'second').val() !== '') {
            ids.push($element.attr('id').slice(0, -5) + 'second');
        }
    }

    if (ids.length === 2) {
        iactUserResetPasswordForm($form, $form.serializeArray(), ids, false);
    }
});
$(document).on("click", "#iact_user_reset_password_submit", function (e) {
    var $form = $(this).closest('form');

    iactUserResetPasswordForm($form, $form.serializeArray(), null, true);
});

var jqxhr_ipof;
var iactPartnerOfferForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_ipof) {
        jqxhr_ipof.abort();
    }
    jqxhr_ipof = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
                auth(data['mfaUrl']);
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_partner_security_login', {_locale: currentLocale,});
            }
        }
    });
};
// Walidacja wyszukiwania ofert w panelu partnera
if ($('.p__dashboard--tiles').length) {
    $(document).on("change", "form[name='interactivo_partner_offer']", function (e) {
        var $form = $(this);
        var $element = $(e.target);

        iactPartnerOfferForm($form, $form.serializeArray(), $element.attr('id'), false);
    });

    $(document).on("click", "#iact_partner_offer_list_submit", function (e) {
        var $form = $(this).closest('form');

        iactPartnerOfferForm($form, $form.serializeArray(), null, true);
    });

    $(document).find("form[name='interactivo_partner_offer']").keypress(function (e) {
        if (e.which == '13') {
            e.preventDefault();

            var $form = $(this).closest('form');

            iactPartnerOfferForm($form, $form.serializeArray(), null, true);
        }
    });
}

var jqxhr_ipopof;
var iactPartnerOfferPathOrderForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_ipopof) {
        jqxhr_ipopof.abort();
    }
    jqxhr_ipopof = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
                auth(data['mfaUrl']);
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_partner_security_login', {_locale: currentLocale,});
            }
        }
    });
};
if ($('.p__dashboard--tiles').length) {
    $(document).on("click", "#iact_partner_offer_path_order_submit", function (e) {
        var $form = $(this).closest('form');

        iactPartnerOfferPathOrderForm($form, $form.serializeArray(), "interactivo_path_order_pathOrder", true);
    });
}

if ($('.submit_foot').length) {
    $(document).on("click", "#clear-conversion-path-order", function (e) {
        $.ajax({
            url: Routing.generate('app_conversion_path_clear', {_locale: currentLocale,}),
            type: 'GET',
            success: function (data) {
                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                    if (data["sessionChanged"] === true) {
                        window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                    }
                }

                $('.lightbox_wrapper[indirect-step]').remove();
                $('body').addClass('unscroll');
                $("body").append(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401) {
                    window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
                }
            }
        });
    });
}

var jqxhr_icif;
var iactClientInvoicesForm = function ($form, params, fieldId, isSubmit) {
    if (jqxhr_icif) {
        jqxhr_icif.abort();
    }
    jqxhr_icif = $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: params,
        success: function (data) {
            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
                if (data["sessionChanged"] === true) {
                    window.location.href = Routing.generate('app_lost_session', {_locale: currentLocale,});
                }
            }

            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
                auth(data['mfaUrl']);
            } else {
                if (isSubmit && data["success"]) {
                    $form.submit();
                } else {
                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
            }
        }
    });
};
if ($('.p__dashboard--documentList').length) {
    $(document).on("click", "#iact-client-invoices-submit", function (e) {
        var $form = $(this).closest('form');

        iactClientInvoicesForm($form, $form.serializeArray(), null, true);
    });
}

$(document).ready(function() {
    if($('form.force-uncheck').length) {
        formForceUncheck();
    }
});


// WEBPACK FOOTER //
// ./assets/js/forms.js